import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const getDateCustom = (data, format) => moment(data).format(format);

export default getDateCustom;
